export default __webpack_public_path__ + "static/210519_魔獄塔更新熱更預告_tc-191e38300016abd397d48965aabb1bf6.webp";